<template>
    <footer>
        <div class="footer-copy" v-scroll-reveal="{ delay: 120 }">
            <h3>
                {{$t('footer.name')}} - {{year}}
            </h3>
            <p>
                {{$t('footer.made_with')}} <i class="fas fa-heart"></i> {{$t('footer.made_in')}}
            </p>
        </div>
        <div>
            <ul class="social-feed text-white">
                <li class="social-feed-item" v-scroll-reveal="{ delay: 251 }">
                    <a href="https://www.facebook.com/slothtech.io" target="_blank">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                </li>
                <li class="social-feed-item" v-scroll-reveal="{ delay: 252 }">
                    <a href="https://twitter.com/slothtech_io" target="_blank">
                        <i class="fab fa-twitter"></i>
                    </a>
                </li>
                <li class="social-feed-item" v-scroll-reveal="{ delay: 253 }">
                    <a href="https://instagram.com/slothtech.io" target="_blank">
                        <i class="fab fa-instagram"></i>
                    </a>
                </li>
                <li class="social-feed-item" v-scroll-reveal="{ delay: 254 }">
                    <a href="https://www.youtube.com/channel/UCp01T2058TTy-IpI7HeZa9w" target="_blank">
                        <i class="fab fa-youtube"></i>
                    </a>
                </li>
                <li class="social-feed-item" v-scroll-reveal="{ delay: 255 }">
                    <a href="https://github.com/slothtechio" target="_blank">
                        <i class="fab fa-github"></i>
                    </a>
                </li>
            </ul>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "SimpleFooter",
        data() {
        return {
            year: new Date().getFullYear() || '2018'
        };
    }
    }
</script>